const backgroundImageBase = `
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export default backgroundImageBase;
